var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showTime.D > 0)?_c('span',[_vm._v(_vm._s(_vm.showTime.D)+"天")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.showTime.H)+":")]),_c('span',[_vm._v(_vm._s(_vm.showTime.M)+":")]),_c('span',[_vm._v(_vm._s(_vm.showTime.S))])])}
var staticRenderFns = []

export { render, staticRenderFns }